document.addEventListener('DOMContentLoaded', () => {
 

  function toggleOpen(e, parentSelector, containerSelector) {
    let btn = e.currentTarget;
    let parent = btn.closest(parentSelector);
    let container = btn.closest(containerSelector);
    if (parent.classList.contains('open')) {
      parent.classList.remove('open');
    } else {
      container.querySelectorAll(parentSelector).forEach(el => el.classList.remove('open'));
      parent.classList.add('open');
    }
  }

  document.querySelectorAll('.footer-block--menu .footer-block__heading_mobile').forEach(btn => {
    btn.addEventListener('click', e => toggleOpen(e, '.footer-block--menu', '.footer__blocks-wrapper'));
  });

  document.querySelectorAll('.footer__blocks-main .footer-block__heading-main').forEach(btn => {
    btn.addEventListener('click', e => toggleOpen(e, '.footer__blocks-main', '.footer_block-adress-with-menus'));
  });
  
});
